module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-menu"
  }, [(!_vm.small) ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/Sporte_Black_Tagline.svg")
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "0 8px"
    },
    attrs: {
      "span": 18
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, _vm._l((_vm.links), function(link) {
    return (_vm.userRole >= link.minRole) ? _c('el-col', {
      key: link.label,
      attrs: {
        "span": _vm.floor(24 / _vm.links.length)
      }
    }, [_c('router-link', {
      staticClass: "link",
      attrs: {
        "to": link.link
      }
    }, [_vm._v("\n              " + _vm._s(link.label) + "\n            ")])], 1) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [(_vm.user.authenticated) ? _c('div', {
    staticClass: "profile-list"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.userName,
      "empty-text": "Error Loading"
    },
    on: {
      "change": function($event) {
        _vm.changeRoute(_vm.value)
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1) : _c('div', {
    staticStyle: {
      "padding": "0 16px"
    }
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1)])], 1)], 1) : _c('div', [_c('div', {
    staticClass: "menu-icon",
    on: {
      "click": function($event) {
        _vm.panelOpen = !_vm.panelOpen
      }
    }
  }, [(_vm.panelOpen) ? _c('div', {
    staticClass: "close"
  }, [_vm._v("✕")]) : _c('div', {
    staticClass: "open"
  }, [_vm._v("≡")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-panel",
    class: {
      open: _vm.panelOpen
    }
  }, [(_vm.user.authenticated) ? _c('div', _vm._l((_vm.options), function(link) {
    return _c('div', {
      key: link.label,
      staticClass: "menu-panel-link",
      on: {
        "click": function($event) {
          _vm.panelOpen = false
        }
      }
    }, [_c('div', {
      staticClass: "link",
      on: {
        "click": function($event) {
          _vm.changeRoute(link.value)
        }
      }
    }, [_vm._v("\n            " + _vm._s(link.label) + "\n          ")])])
  })) : _c('div', [_c('div', {
    staticClass: "menu-panel-link",
    on: {
      "click": function($event) {
        _vm.panelOpen = false
      }
    }
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1)]), _vm._v(" "), _vm._l((_vm.links), function(link) {
    return (_vm.userRole >= link.minRole) ? _c('div', {
      key: link.label,
      staticClass: "menu-panel-link",
      on: {
        "click": function($event) {
          _vm.panelOpen = false
        }
      }
    }, [_c('router-link', {
      staticClass: "link",
      attrs: {
        "to": link.link
      }
    }, [_vm._v("\n          " + _vm._s(link.label) + "\n        ")])], 1) : _vm._e()
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-271b1ee1","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = 424
// module chunks = 23